"use client"
export const CUSTOM_DETAITL_OPTS_EVENT_HELPFUL = "CUSTOM_DETAITL_OPTS_EVENT_HELPFUL";
export const CUSTOM_DETAITL_OPTS_EVENT_ANONYMOUS = "CUSTOM_DETAITL_OPTS_EVENT_ANONYMOUS";
export const CUSTOM_DETAITL_OPTS_EVENT_DELETE = "CUSTOM_DETAITL_OPTS_EVENT_DELETE";
export const CUSTOM_DETAITL_OPTS_EVENT_REPLY = "CUSTOM_DETAITL_OPTS_EVENT_REPLY";
export const customElement = document.createElement("div");
